import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table table-striped" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { colspan: "999" }
const _hoisted_5 = { class: "ellipsis" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Date",
              text: "Date"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati utente",
              text: "Dati utente"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Corrispondenza",
              text: "Corrispondenza"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Messaggio",
              text: "Messaggio"
            })
          ]),
          _hoisted_2
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.errors.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              _createElementVNode("td", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nessun elemento trovato",
                  text: "Nessun elemento trovato"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "yyyy/MM/DD HH:mm:ss")), 1),
            _createElementVNode("td", null, _toDisplayString(item.onOfficeUserIds.userId) + " - " + _toDisplayString(item.onOfficeUserIds.webUserId) + " - " + _toDisplayString(item.onOfficeUserIds.username), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_5, [
                (item.eventIdPair)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(item.eventIdPair.eventOrigin), 1),
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(item.eventIdPair.onOfficeId), 1),
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(item.eventIdPair.googleId), 1),
                      _hoisted_8
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(item.message), 1),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: ($event: any) => (_ctx.dismiss(item))
              }, " x ", 8, _hoisted_9)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}